// extracted by mini-css-extract-plugin
export default {"image":"image__RegionOverviewImage__buBT-","interactiveArea":"interactiveArea__RegionOverviewImage__buBT-"};